import type { CSSProperties } from "react";
import LeftIcon from "@svg/left.svg";

const REGION = "Shop Window Header";

type ShopWindowHeaderProps = {
  src?: string | null;
  hasExitButton?: boolean;
  exitLabel?: string;
  onExit: (region: string) => void;
};

export default function ShopWindowHeader({
  src,
  hasExitButton,
  exitLabel = "Back",
  onExit,
}: ShopWindowHeaderProps) {
  const style: CSSProperties = {};
  if (src) {
    style.backgroundImage = `url(${src})`;
  }
  const exit = hasExitButton ? (
    <button
      type="button"
      className="exit-shop-window hover type-3 button square"
      aria-label={exitLabel}
      onClick={e => {
        e.stopPropagation();
        onExit(REGION);
      }}
    >
      <LeftIcon className="centered icon-left-d" />
    </button>
  ) : null;

  // isLoading never changes from false: the wait cursor, dimming and Loader are never shown.
  const wrapperStyle: CSSProperties = {
    cursor: "pointer",
    opacity: 1,
    position: "relative",
  };

  return (
    <div className="shop-window-header-wrapper" style={wrapperStyle}>
      <div
        className="shop-window-header tw:w-full tw:bg-contain tw:bg-center tw:bg-no-repeat tw:pb-[25%] tw:[.landscape_.experience-container:not(.experience-container--landscape)_.shop-window_&]:pb-[18%]"
        style={style}
      >
        {exit}
      </div>
    </div>
  );
}
